'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageSlideshow = function ImageSlideshow(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
  );
};
ImageSlideshow = (0, _pure2.default)(ImageSlideshow);
ImageSlideshow.displayName = 'ImageSlideshow';

exports.default = ImageSlideshow;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/slideshow.js
 ** module id = 1672
 ** module chunks = 0
 **/